import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import BordereauStatutAnterieurAction from '../actions/BordereauStatutAnterieurAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauRejeteState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.REJETE;
		this.state = BordereauStateType.REJETE;
		this.color = '#A0A0A0';
		this.libelle = 'Rejeté par la collectivité';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
		userRole: UserRole,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [
			new BordereauDupliquerAction({ isActionPrincipale: true }),
			...(userRole === UserRole.ADMIN
				? [
						new BordereauModifierAction({ isSuperUser: true }),
						new BordereauStatutAnterieurAction({ isSuperUser: true }),
					]
				: []),
		];
	}

	getMouvementActions(
		userRole: UserRole,
	): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
		return [
			new MouvementModifierAction({ isReadonly: true }),
			new MouvementDupliquerAction(),
			// pas d'annulation ni de rejet : toutes les pièces d'un bordereau rejeté ou annulé le sont déjà
			...(userRole === UserRole.ADMIN
				? [new MouvementModifierAction({ isSuperUser: true })]
				: []),
		];
	}
}

export default BordereauRejeteState;
